import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { MONTHLY } from "@/constants/expenses_visualizations";

const state = {
  totalExpensesByCostCenter: [],
  expensesSearchResult: [],
  allCostCenterCategories: [],
  saveExpenseSidebar: {
    id: undefined,
    visible: false,
    saveAction: () => {},
  },
  yearIncomeChartData: undefined,
  competenciesExpenses: [],
  competenciesSubcategoriesExpenses: [],
  expensesSearchYear: new Date().getFullYear(),
  expensesSearchVisualization: MONTHLY
};

export default {
  state,
  actions,
  getters,
  mutations,
};
